/**
 * Created by renatolovizotto on 12/07/17.
 */
import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import "../assets/stylesheets/DropdownFilter.scss";

@inject('Navigator', 'AuthStore', 'SchoolStore')
@observer
export default class DropdownLessonByClass extends Component {

        async componentDidMount() {
        const { SchoolStore } = this.props;

    const unitId = SchoolStore.currentClass.unit_id;
    const teacherId = SchoolStore.currentClass.teacher_id;

         if (unitId && teacherId) {
        await SchoolStore.getLessonsByCLassAndDay(unitId, teacherId);
    }
    }

    /*
    ######################################
    # Change/Set LESSON -> Load STUDENTS #
    ######################################
    */
   handleChangeLesson = (lessonSelected) => {
        const { SchoolStore } = this.props;

        SchoolStore.showStudents = true;
        SchoolStore.lessonSelected = lessonSelected;

        // pega objeto inteiro da aula pelo value (id_sf vem do endpoint by day)
    };

    render() {

        //Options do Select de Lessons
        if( this.props.SchoolStore.lessons != undefined){
            var optionsLessons = [];
            this.props.SchoolStore.lessons.forEach(lessonsToOptions);
            function lessonsToOptions(item, index) {

                    if(item.class_date != undefined ){
                        const formattedDate = item.class_date.split('-').reverse().join('/');
                        optionsLessons.push({ value: index, label: formattedDate + ' ' + item.name} );
                    }
                
            }
        }

        return (

            <Select
                name="lessons"
                options={optionsLessons}
                onChange={this.handleChangeLesson.bind(this)}
                placeholder="Selecione a aula"
                className="Dropdown"
                value={this.props.SchoolStore.lessonSelected}
            />

        );
        
    }

}


// WEBPACK FOOTER //
// ./src/containers/DropdownLessonByDay.js